'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConversationsPubSub = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _compose = require('transmute/compose');

var _compose2 = _interopRequireDefault(_compose);

var _debounceApi = require('../../utils/debounceApi');

var _throttleApi = require('../../utils/throttleApi');

var _retryOnce = require('../../utils/retryOnce');

var _omit = require('../../utils/omit');

var _pick = require('../../utils/pick');

var _devLogger = require('conversations-infrastructure/logger/devLogger');

var _decorateCallbacks = require('../operators/decorateCallbacks');

var _preferVendorTimestamp = require('../operators/preferVendorTimestamp');

var _diffSubscriptions = require('./diffSubscriptions');

var _transactSubscriptions2 = require('./transactSubscriptions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConversationsPubSub = exports.ConversationsPubSub = function () {
  function ConversationsPubSub(vendor) {
    _classCallCheck(this, ConversationsPubSub);

    this.vendor = vendor;
    this.subscriptions = {};

    this.publish = (0, _retryOnce.retryOnce)(this.publish.bind(this));
    this.updateSubscriptions = (0, _compose2.default)(_debounceApi.debounceApi, _retryOnce.retryOnce)(this.updateSubscriptions.bind(this));
    this.transactSubscriptions = (0, _compose2.default)(_throttleApi.throttleApi, _retryOnce.retryOnce)(this.transactSubscriptions.bind(this));
    this.connect = (0, _retryOnce.retryOnce)(this.connect.bind(this));
  }

  /**
   * Connect to PubSub.
   *
   * @returns {Promise} connection promise
   */


  _createClass(ConversationsPubSub, [{
    key: 'connect',
    value: function connect() {
      return this.vendor.connect();
    }

    /*
     * Close PubSub connection
     */

  }, {
    key: 'close',
    value: function close() {
      this.vendor.close();
    }

    /**
     * Publish a message on a channel. This method will retry once automatically before failing the publish.
     *
     * @example
     *   const publishObject = {
     *     channel: 'channel.123',
     *     message: { conversations: 'is', awesome: true }
     *   };
     *
     *   client
     *     .publish(publishObject)
     *     .then((messageAsPublished) => console.log('it worked', messageAsPublished))
     *     .catch(error => console.error('it didnt work', error))
     *     .done();
     *
     * @param {Object} publishObject - subscription options
     * @param {Object} publishObject.message - channels to subscribe to
     * @param {String} publishObject.channel - channel groups to subscribe to
     * @returns {Promise}
     */

  }, {
    key: 'publish',
    value: function publish(publishObject) {
      return this.vendor.publish(publishObject).then(_preferVendorTimestamp.preferVendorTimestamp);
    }

    /**
     * Update subscriptions
     *
     * This method is debounced.  Compare the result with `client.updateSubscriptions.DEBOUNCED`
     *
     * When an update is in progress, calls are queued.  When the update completes, the most recent call is
     * invoked and all queued calls receive the result.
     *
     * This method will retry once automatically
     *
     * @example
     *   const subscriptions = {
     *     'channel.123': message => { doSomethingWith(message) }
     *     'channel.456': message => { doSomethingDifferentWith(message) }
     *   };
     *
     *   client
     *     .updateSubscriptions(subscriptions)
     *     .then(result => {
     *       if (result === client.updateSubscriptions.DEBOUNCED) {
     *         // An out of date subscription update was skipped in favor of a more recent update.
     *         return;
     *       }
     *
     *       console.log('it worked')
     *     })
     *     .catch(error => console.error('it didnt work', error))
     *     .done();
     *
     * @param {Object<channelId, messageCallback>} updatedSubscriptions
     * @param {Object} options
     * @param {Number} options.playbackMessagesFrom - (Optional) Replay messages from history after this timestamp
     *
     * @returns {Promise} Resolves with updated subscriptions
     *
     */

    /**
     * Callback provided to `client.updateSubscriptions` to handle received messages.
     *
     * @callback messageCallback
     * @param {Object} message - pubnub message object
     * @param {Object} message.message - conversations message object
     * @param {String} message.channel - channel
     * @param {String} message.timetoken - when the message was published
     */

  }, {
    key: 'updateSubscriptions',
    value: function updateSubscriptions(updatedSubscriptions) {
      var _this = this;

      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          playbackMessagesFrom = _ref.playbackMessagesFrom;

      var decoratedSubscriptions = (0, _decorateCallbacks.decorateCallbacks)(updatedSubscriptions);

      return (0, _diffSubscriptions.diffSubscriptions)({
        vendor: this.vendor,
        currentSubscriptions: this.subscriptions,
        targetSubscriptions: decoratedSubscriptions,
        playbackMessagesFrom: playbackMessagesFrom
      }).then(function () {
        _this.subscriptions = _extends({}, decoratedSubscriptions);
        return _extends({}, _this.subscriptions);
      });
    }

    /**
     * Transact a subscription change
     *
     * This method is throttled and will retry once automatically
     *
     * @example
     *   const toAdd = {
     *     'channel.123': message => { doSomethingWith(message) }
     *   };
     *
     *   const toRemove = {
     *     'channel.456': message => { doSomethingDifferentWith(message) }
     *   };
     *   client
     *     .transactSubscriptions({ toAdd, toRemove})
     *     .then(() => console.log('it worked'))
     *     .catch(error => console.error('it didnt work', error))
     *     .done();
     *
     *
     * @param {Object} options
     * @param {Object<channelId, messageCallback>} options.toAdd subscriptions to add (optional)
     * @param {Array<channelId>} options.toRemove channels to unsubscribe from
     *
     * @returns {Promise} Resolves with updated subscriptions
     *
     */

    /**
     * Callback provided to `client.transactSubscriptions` to handle received messages.
     *
     * @callback messageCallback
     * @param {Object} message - pubnub message object
     * @param {Object} message.message - conversations message object
     * @param {String} message.channel - channel
     * @param {String} message.timetoken - when the message was published
     */

  }, {
    key: 'transactSubscriptions',
    value: function transactSubscriptions(_ref2) {
      var _this2 = this;

      var toAdd = _ref2.toAdd,
          toRemove = _ref2.toRemove;

      var decoratedToAdd = (0, _decorateCallbacks.decorateCallbacks)(toAdd);

      return (0, _transactSubscriptions2.transactSubscriptions)({
        vendor: this.vendor,
        toAdd: decoratedToAdd,
        toRemove: (0, _pick.pick)(this.subscriptions, toRemove)
      }).then(function () {
        _this2.subscriptions = _extends({}, (0, _omit.omit)(_this2.subscriptions, toRemove), decoratedToAdd);

        return _extends({}, _this2.subscriptions);
      });
    }

    /**
     * Temporary Methods
     */

  }, {
    key: 'addListener',
    value: function addListener() {
      (0, _devLogger.warn)('ConversationsPubSub#addListener is deprecated');
    }
  }, {
    key: 'stop',
    value: function stop() {
      (0, _devLogger.warn)('ConversationsPubSub#stop is deprecated');
    }
  }, {
    key: 'reauthorize',
    value: function reauthorize() {
      (0, _devLogger.warn)('ConversationsPubSub#reauthorize is deprecated');
      return this.vendor.reauthorize();
    }
  }, {
    key: 'subscribe',
    value: function subscribe() {
      var _vendor;

      (0, _devLogger.warn)('ConversationsPubSub#subscribe is deprecated');
      return (_vendor = this.vendor).subscribe.apply(_vendor, arguments);
    }
  }, {
    key: 'unsubscribe',
    value: function unsubscribe() {
      var _vendor2;

      (0, _devLogger.warn)('ConversationsPubSub#unsubscribe is deprecated');
      return (_vendor2 = this.vendor).unsubscribe.apply(_vendor2, arguments);
    }
  }]);

  return ConversationsPubSub;
}();


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/conversations-pub-sub/client/ConversationsPubSub.js
// module id = 791
// module chunks = 2 3